<template>
  <b-row>
    <b-col>
      <a class="btn btn-primary" :href="oidcLoginUrl">Log in with GWDG</a>
      <hr />
      <em>Hint: the testing credentials are 'test_user' and 'test_pass'.</em>
      <hr />
      <passthrough-form
        endpoint="/accounts/login/"
        :success-redirect-path="redirectPath"
      />
      <br />
    </b-col>
  </b-row>
</template>
<script>
import PassthroughForm from "@/components/PassthroughForm.vue";

export default {
  name: "Login",
  components: {
    PassthroughForm,
  },
  computed: {
    redirectPath: function () {
      return this.$route.query.next || "/";
    },
    oidcLoginUrl: function () {
      // /oidc/ is proxied straight to observation-portal (not through this app, not through
      // ocs_frontend's own nginx split) -- a plain link, not a router-link, since this needs to
      // leave the SPA entirely for the Keycloak redirect.
      return "/oidc/authenticate/?next=" + encodeURIComponent(this.redirectPath);
    },
  },
};
</script>
